export default (rawCss, prefix = '') => {
  const style = document.createElement('style');
  style.innerHTML = rawCss;
  document.head.appendChild(style);

  const result = Array.from(style.sheet.cssRules)
    .map((rule) => `${prefix} ${rule.cssText}` || '')
    .join('\n');

  document.head.removeChild(style);

  return result;
};
